import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { lazy, Suspense, startTransition } from "react";
import { useState, useEffect } from "react";
import { CartContext } from "./store/shopping-cart-context";

import HeadphonesMarkOne from "./Components/Headphones/HeadphonesMarkOne";
import HeadphonesXX59 from "./Components/Headphones/HeadphonesXX59";
import EarphoneDetail from "./Components/Earphones/EarphoneDetail";
import SpeakerZx7 from "./Components/Speakers/SpeakerZx7";
import SpeakerZx9 from "./Components/Speakers/SpeakerZx9";
import SuccessModal from "./Components/CheckOutForm/SuccessModal";
import CheckoutForm from "./Components/CheckOutForm/CheckoutForm";
import CartCheckOut from "./Components/CartCheckOut/CartCheckOut";
import HeadphonesMarkTwo from "./Components/Headphones/HeadphonesMarkTwo";
import Menu from "./Components/Menu/Menu";
import RootLayout from "./Components/RootLayout";
import AddToCart from "./Components/AddToCart/AddToCart";
import AddToCartB from "./Components/AddToCart/AddToCartB";
import productList from "./Components/CartCheckOut/productData";
import CartItem from "./Components/CartCheckOut/CartItem";

function App() {
  const [shoppingCart, setShoppingCart] = useState({ items: [] });
  const [quantity, setQuantity] = useState(1);
  const increment = () => setQuantity(quantity + 1);
  const decrement = () => setQuantity(quantity - 1 > 0 ? quantity - 1 : 1);
  function handleAddItemToCart(id) {
    setShoppingCart((prevShoppingCart) => {
      // Create a copy of the existing cart items
      const updatedItems = [...prevShoppingCart.items];

      // Find the index of the item in the cart
      const existingCartItemIndex = updatedItems.findIndex(
        (cartItem) => cartItem.id === id
      );

      if (existingCartItemIndex >= 0) {
        // Item exists, update its quantity
        const existingCartItem = updatedItems[existingCartItemIndex];
        const updatedItem = {
          ...existingCartItem,
          quantity: existingCartItem.quantity + 1,
        };
        updatedItems[existingCartItemIndex] = updatedItem;
      } else {
        const product = productList.find((product) => product.id === id);
        if (product) {
          updatedItems.push({
            id: id,
            title: product.title,
            price: product.price,
            quantity: 1,
          });
        }
      }

      // Return the updated shopping cart state
      return { items: updatedItems };
    });
  }

  function handleUpdateCartItemQuantity(productId, amount) {
    setShoppingCart((prevShoppingCart) => {
      const updatedItems = [...prevShoppingCart.items];
      const updatedItemIndex = updatedItems.findIndex(
        (item) => item.id === productId
      );
      if (updatedItemIndex >= 0) {
        const updatedItem = { ...updatedItems[updatedItemIndex] };
        updatedItem.quantity += amount;

        if (updatedItem.quantity <= 0) {
          updatedItems.splice(updatedItemIndex, 1);
        } else {
          updatedItems[updatedItemIndex] = updatedItem;
        }
      }
      console.log("Updating Item Quantity");
      console.log(updatedItems);
      return {
        items: updatedItems,
      };
    });
  }
  const HomePage = lazy(() => import("./Components/HomePage/HomePage"));
  const Headphones = lazy(() => import("./Components/Headphones/Headphones")); //returns a promise
  const Speakers = lazy(() => import("./Components/Speakers/Speakers"));
  const Earphones = lazy(() => import("./Components/Earphones/Earphones"));

  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      children: [
        {
          path: "/",
          element: (
            <Suspense fallback={<p>Loading...</p>}>
              <HomePage />{" "}
            </Suspense>
          ),
        },
        {
          path: "/headphones",
          element: (
            <Suspense fallback={<p>Loading...</p>}>
              <Headphones />
            </Suspense>
          ),
        },
        {
          path: "/speakers",
          element: (
            <Suspense fallback={<p>Loading...</p>}>
              <Speakers />{" "}
            </Suspense>
          ),
        },
        {
          path: "/earphones",
          element: (
            <Suspense fallback={<p>Loading...</p>}>
              <Earphones />{" "}
            </Suspense>
          ),
        },

        {
          path: "/headphones/markOne",
          element: (
            <HeadphonesMarkOne
              cart={shoppingCart}
              updateMyCart={handleAddItemToCart}
              updateQuantity={handleUpdateCartItemQuantity}
              increment={increment}
              decrement={decrement}
              quantity={quantity}
            />
          ),
        },
        {
          path: "/headphones/markTwo",
          element: (
            <HeadphonesMarkTwo
              cart={shoppingCart}
              updateMyCart={handleAddItemToCart}
              updateQuantity={handleUpdateCartItemQuantity}
              increment={increment}
              decrement={decrement}
              quantity={quantity}
            />
          ),
        },
        {
          path: "/headphones/xx59",
          element: (
            <HeadphonesXX59
              cart={shoppingCart}
              updateMyCart={handleAddItemToCart}
              updateQuantity={handleUpdateCartItemQuantity}
              increment={increment}
              decrement={decrement}
              quantity={quantity}
            />
          ),
        },

        {
          path: "/speakerZx7",
          element: (
            <SpeakerZx7
              cart={shoppingCart}
              updateMyCart={handleAddItemToCart}
              updateQuantity={handleUpdateCartItemQuantity}
              increment={increment}
              decrement={decrement}
              quantity={quantity}
            />
          ),
        },
        {
          path: "/speakerZx9",
          element: (
            <SpeakerZx9
              cart={shoppingCart}
              updateMyCart={handleAddItemToCart}
              updateQuantity={handleUpdateCartItemQuantity}
              increment={increment}
              decrement={decrement}
              quantity={quantity}
            />
          ),
        },

        {
          path: "/earphoneDetail",
          element: (
            <EarphoneDetail
              cart={shoppingCart}
              updateMyCart={handleAddItemToCart}
              updateQuantity={handleUpdateCartItemQuantity}
              increment={increment}
              decrement={decrement}
              quantity={quantity}
            />
          ),
        },
        {
          path: "/checkoutform",
          element: <CheckoutForm />,
        },
        {
          path: "/successmodal",
          element: <SuccessModal />,
        },
      ],
    },
  ]);

  return (
    <CartContext.Provider
      value={{
        items: [],
        incrementItem: increment,
        decrementItem: decrement,
      }}
    >
      <RouterProvider router={router} />
    </CartContext.Provider>
  );
}

export default App;
